// Mock data for REACT_APP_MOCK=true demo mode

export const MOCK_USER = {
  user_id: 'mock-user-001',
  email: 'demo@acmeconsulting.eu',
  is_admin: true,
  subscription_status: 'active',
  subscription_tier: 'tier2',
  tier: 'tier2',
  label: 'Growth',
  price_eur: 34,
  is_paid: true,
  limits: {
    max_profiles: 5, max_users: 10, max_matches: null, daily_match_limit: null,
    matches_refresh: true, max_countries: null, email_alerts: true,
    api_access: true, sales_portal_api: true,
  },
};

export const MOCK_ADMIN_USERS = [
  { id: 'mock-user-001', email: 'demo@acmeconsulting.eu', created_at: '2024-10-01T10:00:00Z', subscription_status: 'active', is_admin: true, profile_count: 1, match_count: 8 },
  { id: 'mock-user-002', email: 'info@buildeu.de', created_at: '2024-11-15T09:00:00Z', subscription_status: 'trial', is_admin: false, profile_count: 1, match_count: 5 },
  { id: 'mock-user-003', email: 'procurement@medsupply.be', created_at: '2025-01-03T14:00:00Z', subscription_status: 'trial', is_admin: false, profile_count: 1, match_count: 3 },
];

export const MOCK_ADMIN_STATS = {
  total_users: 3,
  total_tenders: 140,
  embedded_tenders: 140,
  pending_matches: 0,
  last_ingestion: {
    id: 'run-001',
    started_at: new Date(Date.now() - 3600000).toISOString(),
    completed_at: new Date(Date.now() - 3540000).toISOString(),
    tenders_fetched: 100,
    tenders_embedded: 100,
    status: 'completed',
    error: null,
  },
};

export const MOCK_INGESTION_RUNS = [
  { id: 'run-001', started_at: new Date(Date.now() - 3600000).toISOString(), completed_at: new Date(Date.now() - 3540000).toISOString(), tenders_fetched: 100, tenders_embedded: 100, status: 'completed', error: null },
  { id: 'run-002', started_at: new Date(Date.now() - 90000000).toISOString(), completed_at: new Date(Date.now() - 89940000).toISOString(), tenders_fetched: 80, tenders_embedded: 80, status: 'completed', error: null },
];

export const MOCK_TOKEN = 'mock-jwt-token-for-demo';

export const MOCK_PROFILE = {
  company_name: 'Acme Consulting GmbH',
  country: 'Germany',
  company_size: '51-200',
  sector: 'IT & Software',
  specialisations: ['Cloud Infrastructure', 'Cybersecurity', 'Digital Transformation'],
  certifications: ['ISO 27001', 'ISO 9001'],
  experience_years: 12,
  eu_projects: true,
  operating_countries: ['DEU', 'NLD', 'BEL', 'AUT', 'CHE'],
  keywords: 'Public sector cloud migrations, cybersecurity audits, GDPR compliance, government IT modernisation',
  cpv_interests: ['72', '48', '73'],
  procurement_types: ['Consulting / advisory', 'Software development', 'Maintenance & support'],
  languages: ['English', 'German'],
};

function daysFromNow(n) {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

export const MOCK_MATCHES = [
  {
    tender: {
      id: 't001',
      title: 'Cloud Infrastructure Modernisation for Federal Tax Authority',
      country: 'Germany',
      deadline: daysFromNow(42),
      contract_value: 2400000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72212000', '72263000', '72267000', '72268000'],
      ted_id: '198432-2026',
      description_en: 'The Federal Tax Authority (Bundeszentralamt für Steuern) seeks a qualified provider for the migration of its on-premises data centre infrastructure to a hybrid cloud architecture. The project encompasses cloud readiness assessment, infrastructure design, phased migration of 14 internal applications, implementation of GDPR-compliant data handling procedures, and a 24-month hypercare support period post-migration. The successful bidder must demonstrate prior experience with federal government cloud projects and hold current ISO 27001 certification.',
      buyer_name: 'Bundeszentralamt für Steuern',
      buyer_city: 'Bonn',
      buyer_url: 'https://www.bzst.de',
      buyer_type: 'body-pl-cga',
      procedure_type: 'open',
      submission_language: 'DEU',
      award_criterion_type: 'quality',
      award_criterion_description: 'Technical quality (50%), Price (30%), Experience with comparable projects (20%). Minimum technical score of 65/100 required to be considered for financial evaluation.',
      selection_criteria: 'Minimum annual turnover of €5M in IT services for the last 3 years. At least 2 references for comparable cloud migration projects in the public sector. ISO 27001 certification mandatory. Proof of GDPR compliance framework required.',
      contract_start: daysFromNow(90),
      contract_end: daysFromNow(90 + 730),
      framework_agreement: null,
      eu_funded: false,
      document_url: 'https://ted.europa.eu/en/notice/-/detail/198432-2026',
      submission_url: 'https://www.evergabe-online.de/tenders/198432-2026',
      additional_info: 'Mandatory site visit on ' + daysFromNow(14) + '. Questions must be submitted via the platform no later than 10 days before the deadline. All communications must be in German.',
      nuts_code: 'DEA22',
      performance_country: 'Germany',
      notice_type: 'cn-standard',
      contract_nature: 'services',
      estimated_value: 2400000,
    },
    score: 94,
    reasoning: 'Strong match: federal government cloud migration aligns directly with your cloud infrastructure specialisation and public-sector experience. ISO 27001 certification is explicitly required — you hold it. Contract scope covers GDPR compliance advisory, one of your stated keywords.',
  },
  {
    tender: {
      id: 't002',
      title: 'Cybersecurity Audit and Penetration Testing — National Health Service IT',
      country: 'Netherlands',
      deadline: daysFromNow(28),
      contract_value: 380000,
      contract_size_band: 'medium',
      cpv_codes: ['72212000', '72000000'],
    },
    score: 91,
    reasoning: 'Near-perfect match: cybersecurity audit is your core offering. ISO 27001 required. Netherlands is in your operating countries (NLD). Healthcare sector IT is adjacent to your sector experience.',
  },
  {
    tender: {
      id: 't003',
      title: 'GDPR Compliance Framework Implementation for Regional Government',
      country: 'Belgium',
      deadline: daysFromNow(55),
      contract_value: 210000,
      contract_size_band: 'medium',
      cpv_codes: ['72000000', '72212000'],
    },
    score: 89,
    reasoning: 'GDPR compliance implementation is explicitly listed in your keywords. Regional government is a strong public-sector fit. Belgium (BEL) is an operating country for you.',
  },
  {
    tender: {
      id: 't004',
      title: 'Digital Transformation Roadmap for Public Transport Authority',
      country: 'Austria',
      deadline: daysFromNow(67),
      contract_value: 950000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72212000', '72263000', '72220000', '72250000'],
    },
    score: 86,
    reasoning: 'Digital transformation is a core specialisation. Austria (AUT) is in your operating countries. Public sector client matches your government IT experience. Contract value is within your typical project range.',
  },
  {
    tender: {
      id: 't005',
      title: 'Enterprise Security Operations Centre Setup and Management',
      country: 'Switzerland',
      deadline: daysFromNow(34),
      contract_value: 1800000,
      contract_size_band: 'large',
      cpv_codes: ['72212000', '72000000', '72267000'],
    },
    score: 84,
    reasoning: 'SOC setup is directly within your cybersecurity capability. Switzerland (CHE) is listed as an operating country. ISO 27001 is a stated requirement, which you hold.',
  },
  {
    tender: {
      id: 't029',
      title: 'Vulnerability Management Platform Deployment — Financial Regulator',
      country: 'Germany',
      deadline: daysFromNow(36),
      contract_value: 340000,
      contract_size_band: 'medium',
      cpv_codes: ['72212000', '72000000', '72267000'],
    },
    score: 88,
    reasoning: 'Vulnerability management is core cybersecurity work. Financial regulator is a government-adjacent body. ISO 27001 required. Strong overlap with your stated capabilities.',
  },
  {
    tender: {
      id: 't021',
      title: 'National Cyber Incident Response Framework Development',
      country: 'Netherlands',
      deadline: daysFromNow(40),
      contract_value: 780000,
      contract_size_band: 'large',
      cpv_codes: ['72212000', '72000000', '72267000'],
    },
    score: 83,
    reasoning: 'Incident response framework development is high-value cybersecurity work matching your core offering. National-level engagement suits your EU project experience. ISO 27001 required.',
  },
  {
    tender: {
      id: 't006',
      title: 'IT Infrastructure Assessment and Cloud Migration Strategy — Ministry of Education',
      country: 'Germany',
      deadline: daysFromNow(45),
      contract_value: 520000,
      contract_size_band: 'medium',
      cpv_codes: ['72000000', '72263000', '72212000'],
    },
    score: 82,
    reasoning: 'Cloud migration strategy work for a government ministry is highly aligned with your profile. Germany is your home country. Ministry of Education falls under public sector, a strong fit.',
  },
  {
    tender: {
      id: 't007',
      title: 'Network Security Review and Zero-Trust Architecture Design',
      country: 'Netherlands',
      deadline: daysFromNow(21),
      contract_value: 175000,
      contract_size_band: 'small',
      cpv_codes: ['72212000', '72000000'],
    },
    score: 79,
    reasoning: 'Network security and zero-trust design falls within your cybersecurity specialisation. Short deadline may be a risk. Netherlands is a target operating country.',
  },
  {
    tender: {
      id: 't008',
      title: 'Data Centre Consolidation and Virtualisation — State Government IT',
      country: 'Germany',
      deadline: daysFromNow(80),
      contract_value: 3200000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72268000', '72263000', '72250000', '72212000', '48000000'],
    },
    score: 77,
    reasoning: 'Data centre consolidation is adjacent to your cloud infrastructure work. Large contract value is within your company size range. State government client aligns with public-sector keywords.',
  },
  {
    tender: {
      id: 't009',
      title: 'Supply Chain Cybersecurity Risk Assessment for Defence Procurement Agency',
      country: 'Belgium',
      deadline: daysFromNow(38),
      contract_value: 290000,
      contract_size_band: 'medium',
      cpv_codes: ['72212000', '72000000', '72267000'],
    },
    score: 75,
    reasoning: 'Supply chain cybersecurity is a niche application of your core competency. Defence sector slightly outside your primary sector but cybersecurity expertise is directly applicable. Belgium is an operating country.',
  },
  {
    tender: {
      id: 't010',
      title: 'Digital Identity Management Platform for Social Security Administration',
      country: 'Germany',
      deadline: daysFromNow(51),
      contract_value: 1100000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72212000', '72263000'],
    },
    score: 73,
    reasoning: 'Digital identity platforms require cloud infrastructure and security expertise — both in your wheelhouse. Social security administration is a government client, matching your public-sector experience.',
  },
  {
    tender: {
      id: 't020',
      title: 'Legacy System Integration with Cloud-Native APIs — Customs Agency',
      country: 'Belgium',
      deadline: daysFromNow(55),
      contract_value: 430000,
      contract_size_band: 'medium',
      cpv_codes: ['72263000', '72000000', '72212000'],
    },
    score: 72,
    reasoning: 'API integration for legacy-to-cloud migration is core cloud infrastructure work. Customs Agency is a government client. Belgium is in your operating countries.',
  },
  {
    tender: {
      id: 't011',
      title: 'Managed Security Service Provider Contract — Regional Police IT',
      country: 'Austria',
      deadline: daysFromNow(60),
      contract_value: 650000,
      contract_size_band: 'medium',
      cpv_codes: ['72212000', '72000000', '72267000', '72268000'],
    },
    score: 71,
    reasoning: 'Managed security services draws on both your cloud and cybersecurity capabilities. Police IT is public sector. Austria is an operating country. ISO 27001 required.',
  },
  {
    tender: {
      id: 't012',
      title: 'Public Procurement Portal Modernisation — Federal Procurement Office',
      country: 'Germany',
      deadline: daysFromNow(90),
      contract_value: 870000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72263000', '72212000', '72220000'],
    },
    score: 69,
    reasoning: 'Portal modernisation is a digital transformation project aligned with your specialisation. Federal client is a strong fit. Requires demonstrated prior government IT delivery experience, which your EU projects history supports.',
  },
  {
    tender: {
      id: 't013',
      title: 'IT Disaster Recovery Planning and Business Continuity Consulting',
      country: 'Netherlands',
      deadline: daysFromNow(44),
      contract_value: 140000,
      contract_size_band: 'small',
      cpv_codes: ['72000000', '72267000'],
    },
    score: 67,
    reasoning: 'DR/BCP consulting is adjacent to cloud infrastructure and security. Smaller contract, good fit for capacity. Netherlands is a target market.',
  },
  {
    tender: {
      id: 't030',
      title: 'IT Governance Framework Review for Pension Fund Authority',
      country: 'Netherlands',
      deadline: daysFromNow(77),
      contract_value: 190000,
      contract_size_band: 'medium',
      cpv_codes: ['72000000', '72220000'],
    },
    score: 65,
    reasoning: 'IT governance consulting draws on your ISO 9001 and general IT advisory experience. Pension fund authority is a public-sector body. Netherlands is an operating country.',
  },
  {
    tender: {
      id: 't014',
      title: 'Open Source ERP Migration for Municipal Administration',
      country: 'Belgium',
      deadline: daysFromNow(73),
      contract_value: 320000,
      contract_size_band: 'medium',
      cpv_codes: ['48000000', '72263000', '72000000'],
    },
    score: 64,
    reasoning: 'ERP migration is a form of digital transformation. Municipal administration is public sector. Some overlap with your profile but ERP-specific experience not explicitly listed.',
  },
  {
    tender: {
      id: 't022',
      title: 'Cloud Cost Optimisation Consultancy for Public University Consortium',
      country: 'Germany',
      deadline: daysFromNow(33),
      contract_value: 90000,
      contract_size_band: 'small',
      cpv_codes: ['72000000', '72263000'],
    },
    score: 68,
    reasoning: 'Cloud cost optimisation is a natural service extension for a cloud infrastructure specialist. University consortium is public sector adjacent. Small contract but good profile fit.',
  },
  {
    tender: {
      id: 't015',
      title: 'Cybersecurity Training Programme for Civil Service Staff',
      country: 'Germany',
      deadline: daysFromNow(30),
      contract_value: 95000,
      contract_size_band: 'small',
      cpv_codes: ['80533000', '72212000'],
    },
    score: 62,
    reasoning: 'Cybersecurity training is a natural extension of your security consulting work. Small contract. Civil service client is public sector. Training delivery experience not explicitly stated in your profile.',
  },
  {
    tender: {
      id: 't016',
      title: 'Smart City IoT Platform Integration — City of Rotterdam',
      country: 'Netherlands',
      deadline: daysFromNow(85),
      contract_value: 1650000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72212000', '72263000', '48000000', '32000000'],
    },
    score: 60,
    reasoning: 'IoT platform integration requires cloud infrastructure skills you have. Smart city is public sector. However IoT/edge computing is not explicitly listed as a specialisation — partial match.',
  },
  {
    tender: {
      id: 't017',
      title: 'Data Protection Officer Services — Healthcare Network',
      country: 'Switzerland',
      deadline: daysFromNow(25),
      contract_value: 85000,
      contract_size_band: 'small',
      cpv_codes: ['72000000'],
    },
    score: 58,
    reasoning: 'DPO services draw on GDPR expertise listed in your keywords. Healthcare sector is adjacent. Switzerland is an operating country. Small contract value.',
  },
  {
    tender: {
      id: 't018',
      title: 'Software Asset Management and Licence Compliance Audit',
      country: 'Germany',
      deadline: daysFromNow(48),
      contract_value: 120000,
      contract_size_band: 'small',
      cpv_codes: ['72267000', '72000000'],
    },
    score: 56,
    reasoning: 'SAM/licence audit is a form of IT consulting adjacent to your profile. Moderate match — your ISO 9001 certification supports quality management process work.',
  },
  {
    tender: {
      id: 't019',
      title: 'E-Government Service Accessibility Review and Remediation',
      country: 'Austria',
      deadline: daysFromNow(62),
      contract_value: 165000,
      contract_size_band: 'small',
      cpv_codes: ['72000000', '72212000'],
    },
    score: 54,
    reasoning: 'E-government accessibility work falls under digital transformation. Austria is an operating country. However, accessibility/UX expertise is not in your stated specialisations.',
  },
  {
    tender: {
      id: 't023',
      title: 'Border Control Biometric IT System Upgrade',
      country: 'Austria',
      deadline: daysFromNow(95),
      contract_value: 4500000,
      contract_size_band: 'large',
      cpv_codes: ['72000000', '72212000', '72263000', '72267000', '48000000', '98000000'],
    },
    score: 51,
    reasoning: 'Large IT systems project requiring security clearance. Your security expertise is relevant but biometric systems are a specialist niche. High competition expected. Security clearance requirements may be a barrier.',
  },
  {
    tender: {
      id: 't024',
      title: 'Procurement Management System for Hospital Group',
      country: 'Netherlands',
      deadline: daysFromNow(58),
      contract_value: 265000,
      contract_size_band: 'medium',
      cpv_codes: ['48000000', '72263000'],
    },
    score: 44,
    reasoning: 'Procurement system implementation is more ERP/application-specific than your stated focus areas. Healthcare sector is adjacent. Weaker match overall.',
  },
  {
    tender: {
      id: 't025',
      title: 'Public Wi-Fi Infrastructure Deployment — City of Brussels',
      country: 'Belgium',
      deadline: daysFromNow(70),
      contract_value: 1200000,
      contract_size_band: 'large',
      cpv_codes: ['32000000', '72000000'],
    },
    score: 41,
    reasoning: 'Physical Wi-Fi infrastructure deployment requires hardware delivery and network engineering beyond typical consulting scope. Limited alignment with your advisory-focused profile.',
  },
  {
    tender: {
      id: 't026',
      title: 'Translation Services for EU Regulatory Documentation',
      country: 'Belgium',
      deadline: daysFromNow(15),
      contract_value: 55000,
      contract_size_band: 'small',
      cpv_codes: ['79000000'],
    },
    score: 12,
    reasoning: 'Language/translation services. No relevance to IT consulting profile.',
  },
  {
    tender: {
      id: 't027',
      title: 'Road Maintenance and Resurfacing — Highway Network Section A12',
      country: 'Netherlands',
      deadline: daysFromNow(22),
      contract_value: 8700000,
      contract_size_band: 'large',
      cpv_codes: ['45000000', '45233000'],
    },
    score: 8,
    reasoning: 'Civil engineering/construction tender. No relevance to IT consulting profile.',
  },
  {
    tender: {
      id: 't028',
      title: 'Office Supplies Framework Agreement — Federal Administration',
      country: 'Germany',
      deadline: daysFromNow(50),
      contract_value: null,
      contract_size_band: 'unknown',
      cpv_codes: ['30000000'],
    },
    score: 5,
    reasoning: 'Office supplies procurement. No relevance to IT consulting profile.',
  },
];
